import React from 'react';
interface StageLayoutProps {
  copy: React.ReactNode;
  visual?: React.ReactNode;
  /** Centre a single column when the page is pure statement. */
  centered?: boolean;
  /** Photography that bleeds off the right edge of the canvas, behind the copy. */
  bleed?: React.ReactNode;
}

/**
 * Shared composition for the player canvas: copy on the left, clinical visual
 * or clinician photography on the right, clear of the timer and control bar.
 */
export function StageLayout({
  copy,
  visual,
  centered = false,
  bleed
}: StageLayoutProps) {
  const bleedLayer = bleed ? <div className="pointer-events-none absolute inset-y-0 right-0 hidden w-[46%] overflow-hidden sm:block" data-id="element-242" data-mp="3czmzp9dt1pxn">
      {bleed}
    </div> : null;
  if (centered || !visual) {
    return <div className="relative h-full w-full overflow-hidden" data-id="element-243" data-mp="390fctih3fxo5">
        {bleedLayer}
        <div className="relative z-10 flex h-full w-full flex-col justify-center px-6 pb-12 pt-14 md:px-14 md:pb-14 md:pt-16" data-id="element-244" data-mp="3mvq3ejob1wmp">
          <div className="max-w-[520px]" data-id="element-245" data-mp="2mjqvux3z76fq">{copy}</div>
        </div>
      </div>;
  }
  return <div className="relative h-full w-full overflow-hidden" data-id="element-246" data-mp="2rik7sl3m6pds">
      {bleedLayer}
      <div className="relative z-10 grid h-full w-full grid-rows-[auto_1fr] items-center gap-4 px-6 pb-12 pt-14 md:grid-cols-2 md:grid-rows-1 md:gap-10 md:px-14 md:pb-14 md:pt-16" data-id="element-247" data-mp="2rkey6exnn9p9">
        <div className="flex flex-col justify-center" data-id="element-248" data-mp="30kl8xt1yxvkq">{copy}</div>
        <div className="flex min-h-0 w-full items-center justify-center" data-id="element-249" data-mp="35hbmo9qawf2z">
          {visual}
        </div>
      </div>
    </div>;
}